// extracted by mini-css-extract-plugin
export default {"container":"_216mH","title":"_2lpWF"};